import * as mutations from './mutations';
import * as getters from './getters';
import * as actions from './actions';
import { getLoanNumber } from '@/storage';
import { UserState } from '@/interfaces/user';
import { AchProviders } from '@/constants/payments';

export default {
  namespaced: true,
  state: {
    ach_provider: AchProviders.Crb,
    has_payment_method: false,
    loans: [],
    email: '',
    activeLoanNumber: getLoanNumber(),
    isFirstLogin: false,
  } as UserState,
  getters,
  mutations,
  actions,
};
